import React from 'react';

export const Affiliations = () => {
  const affiliations = [
    {
      name: 'Vistage',
      logo: '/assets/images/vistage-logo.png',
      url: 'https://www.vistage.com/'
    },
    {
      name: 'Chamber of Commerce',
      logo: '/assets/images/mgma-logo.png',
      url: 'https://www.uschamberfoundation.org/'
    },
    {
      name: 'American Medical Billing Association',
      logo: '/assets/images/amba-logo.jpg',
      url: 'https://www.americanmedicalbillingassociation.com/'
    }
  ];

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10">
          <span className="inline-block bg-navy-600 text-white px-6 py-2 rounded-full text-sm font-semibold">
            OUR COMMUNITY
          </span>
          <p className="mt-4 text-gray-600">
            Proud member of leading healthcare and business organizations
          </p>
        </div>

        {/* Logos Grid */}
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-16">
          {affiliations.map((affiliation, index) => (
            <a
              key={index}
              href={affiliation.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-center p-6 rounded-2xl bg-gray-50 hover:bg-teal-50 border border-gray-100 hover:border-teal-200 transition-all duration-300"
              aria-label={`Visit ${affiliation.name} website`}
            >
              <img
                src={affiliation.logo}
                alt={affiliation.name}
                loading="lazy"
                decoding="async"
                width="120"
                height="60"
                className="h-14 md:h-16 w-auto object-contain opacity-70 group-hover:opacity-100 transition-opacity duration-300"
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
